import React from "react";
import styled from "styled-components";

import cx from "classnames";
import "./Button.scss";

const StyledButton = styled.button`
  &[disabled] {
    opacity: 0.3;
    &:hover {
    }
  }
`;

type ButtonSize = "small" | "middle" | "large" | undefined;

type ButtonType =
  | "default"
  | "primary"
  | "ghost"
  | "dashed"
  | "danger"
  | "link"
  | "secondary";
type ButtonShape = "circle" | "circle-outline" | "round";

export interface BaseButtonProps {
  type?: ButtonType;
  icon?: React.ReactNode;
  shape?: ButtonShape;
  size?: ButtonSize;
  loading?: boolean | { delay?: number };
  prefixCls?: string;
  className?: string;
  ghost?: boolean;
  danger?: boolean;
  block?: boolean;
  children?: React.ReactNode;
  htmlTyp?: "submit" | "button" | "reset";
  disabled?: any;
  onClick?: (arg: any) => void;
}

const Button = (props: BaseButtonProps) => {
  const { loading, className, disabled, ...restProps } = props;
  const { type, shape, size: customizeSize } = props;

  const prefixCls = "btn";
  let sizeCls = "";
  switch (customizeSize) {
    case "large":
      sizeCls = "lg";
      break;
    case "small":
      sizeCls = "sm";
      break;
    default:
      break;
  }
  const classes = cx(prefixCls, {
    [`${prefixCls}-${type}`]: type,
    [`${prefixCls}-${shape}`]: shape,
    [`${prefixCls}-${sizeCls}`]: sizeCls,
  });
  return (
    <StyledButton className={classes} disabled={disabled} {...restProps} />
  );
};

Button.defaultProps = {
  loading: false,
  ghost: false,
  block: false,
  htmlType: "button",
};

export default Button;
